import React from 'react';
import { useLocation, useParams } from 'react-router';

import { ClubRoute, MemberRoute } from '@swf/core/types/Poker';
import { MainNav, useGetContentRoutes } from '@swf/poker';

import styles from '../MainNav.scss';

import {
  TXTCLI_Announcements,
  TXTCLI_Club_Lobby,
  TXTCLI_Members,
  TXTCLI_Results
} from './ClubNav.messages.json';

const ClubNav = () => {
  const { pathname } = useLocation();
  const { clubsPath } = useGetContentRoutes();
  const { clubId } = useParams<{ clubId: string }>();
  const links = [
    { translation: TXTCLI_Club_Lobby, href: `${clubsPath}/${clubId}/${ClubRoute.Lobby}` },
    { translation: TXTCLI_Results, href: `${clubsPath}/${clubId}/${ClubRoute.Results}` },
    {
      active: pathname.includes(`${clubsPath}/${clubId}/${ClubRoute.Members}`),
      translation: TXTCLI_Members,
      href: `${clubsPath}/${clubId}/${ClubRoute.Members}/${MemberRoute.List}`
    },
    {
      translation: TXTCLI_Announcements,
      href: `${clubsPath}/${clubId}/${ClubRoute.Announcements}`
    }
  ];

  return <MainNav links={links} innerClassName={styles.clubNav} />;
};

export default ClubNav;
